import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export const exportEvaluationData = async (
  evaluation: string,
  evaldata: any
) => {
  try {
    const fileName = `${evaluation}.xlsx`;
    const workbook = new ExcelJS.Workbook();

    Object.entries(evaldata).forEach(([key, value]) => {
      const worksheet = workbook.addWorksheet(`${key.toString().trim()}`);
      worksheet.columns = [
        { header: "Sub-section", key: "subsection", width: 50 },
        {
          header: "Question Number",
          key: "qnum",
          width: 10,
          style: { alignment: { horizontal: "center" } },
        },
        { header: "Question", key: "question", width: 50 },
        {
          header: "Answer",
          key: "response",
          width: 10,
          style: { alignment: { horizontal: "center" } },
        },
        { header: "Justification", key: "justification", width: 50 },
        { header: "Additional Notes", key: "note", width: 50 },
        { header: "Actions", key: "actions_planned", width: 50 },
      ];
      if (Array.isArray(value)) {
        if (value.length > 0) {
          worksheet.addRows(value);
        }
      }

      const headerRow = worksheet.getRow(1); // Get the first row (header)
      headerRow.font = {
        name: "Arial",
        bold: true,
        size: 12,
        color: { argb: "FFFFFFFF" },
      }; // White text
      headerRow.fill = {
        // Apply background color
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF4F81BD" }, // A shade of blue
      };
      headerRow.alignment = { vertical: "middle", horizontal: "center" }; // Center align header text

      // Apply border to header cells
      headerRow.eachCell((cell) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });

      // f) Optional: Add AutoFilter to the header row
      worksheet.autoFilter = {
        from: "A1", // Apply filter from cell A1
        to: {
          // To the last column of the header row
          row: 1,
          column: worksheet.columns.length,
        },
      };

      // g) Optional: Freeze the Header Row
      worksheet.views = [
        { state: "frozen", ySplit: 1 }, // Freezes the top row (ySplit = 1 means freeze everything above row 1)
      ];
    });
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `${fileName}`);
  } catch (error) {
    console.log("Could not export evaluation data", error);
  }
};
